import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<unknown>({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '12px',
  },
  closeButton: {
    padding: '0px',
    'MuiIconButton-label': {
      '& svg': {
        cursor: 'pointer',
      },
    },
  },
  dialog: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    position: 'relative',
    height: '100dvh',
    fontSize: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '& .MuiAccordion-root': {
      width: '100%',
    },
  },
  dialogTitle: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    fontSize: '20px',
    // @ts-expect-error - this is a valid font weight
    fontWeight: '600',
  },
  sectionTitle: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    fontSize: '16px',
    // @ts-expect-error - this is a valid font weight
    fontWeight: '500',
    color: '#00000099',
  },
  topSection: {
    border: 'none',
    '&:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-content': {
      margin: '0',
    },
  },
  topSectionInner: {
    display: 'grid',
    gap: '16px',
  },
  detailsSection: {
    backgroundColor: '#F7F8FA',
    display: 'flex',
  },
  detailsSectionInner: {
    backgroundColor: '#F7F8FA',
  },
  notesSection: () => ({
    backgroundColor: '#F7F8FA',
    padding: '0 24px 24px 24px',
    overflowY: 'scroll',
  }),
  notesSectionHeader: () => ({
    backgroundColor: '#F7F8FA',
    padding: '24px 24px 12px 24px',
    boxShadow: '0px 3px 5px rgba(255, 255, 255, 1)',
  }),
  notesInner: {
    display: 'grid',
    gap: '24px',
  },
  notesLayout: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: '24px',
  },
  noteDetail: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    fontSize: '12px',
    color: '#00000099',
  },
  noteText: {
    // @ts-expect-error - this is a valid value
    overflowWrap: 'anywhere',
    margin: '4px 0',
  },
  actionSection: {
    backgroundColor: '#F7F8FA',
    display: 'flex',
    marginTop: 'auto',
    width: '100%',
    justifyContent: 'flex-end',
    padding: '16px',
    gap: '12px',
  },
  viewClientButtonLink: {
    padding: '10px 16px',
    textDecoration: 'none',
  },
  taskDetail: {
    display: 'grid',
    gap: '12px',
    gridTemplateColumns: '1fr 3fr',
    alignItems: 'center',
    // @ts-expect-error - this is a valid value for overflow-wrap in all browsers in Chrome 80/Safari 15.4
    overflowWrap: 'anywhere',
  },
  taskDetailContents: {
    display: 'flex',
    gap: '12px',
  },
  taskLink: {
    textDecoration: 'underline',
    color: '#3f51b5',
    cursor: 'pointer',
    '&:hover': {
      color: '#2d3c8f',
    },
  },
  resolutionText: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
  },
  secondaryButton: {
    backgroundColor: '#F7F8FA',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 'bold',
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    border: '1px solid #00000040',
    borderRadius: '8px',
    padding: '10px 16px',
    color: '#000000DE',
    transition: 'all linear 0.5s',
    cursor: 'pointer',
    '&:hover': {
      textTransform: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  primaryButton: {
    backgroundColor: '#0A5AC2',
    textTransform: 'none',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 16px',
    color: '#FFFFFF',
    transition: 'all linear 0.5s',
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#013e8f',
      textTransform: 'none',
    },
  },
});
